import { alertConstants } from "../_constants";

export const alertActions = {
  loading,
  success,
  error,
  clear
};

function loading() {
  return { type: alertConstants.LOADING };
}

function success(message) {
  return { type: alertConstants.SUCCESS, message };
}

function error(message) {
  return { type: alertConstants.ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}
